import React, {useEffect, useState} from 'react'
import {Divider, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import SingleVariant from './positions/SingleVariant';
import MultiVariant from './positions/MultiVariant';
import Tr from 'translations/Translations';
import getObjectValue from 'libs/getObjectValue';
import AddButton from 'components/button/AddButton';
import {newItem} from '../constants/initialValues';
import ItemPopup from './positions/ItemPopup';
import _ from 'lodash';
import {CRYTERIUM_TYPE} from "components/popup/newCriteria/constants/criterium.type";
import {PriceDirections} from "constants/DirectionsItems";
import {ITEM_TYPES} from "../constants/itemTypes";
import Confirm from "../../../../../../../../components/popup/confirm/Confirm";
import removeFormikListElement from "../../../../../../../../libs/removeFormikListElement";
import {connect} from "react-redux";
import {DemandValidation} from "constants/DemandValidation";

const style = theme => ({
    root: {
        width: '100%',
        '&>*': {
            width: 'inherit'
        }
    },
    header: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        fontWeight: theme.typography.fontWeightBold,
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    }
})

function PositionsSection({
    classes,
    formikProps,
    id,
    dealingId,
    priceType,
    demandValidation
}) {

    const [editingItem, setEditingItem] = useState(null);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [deleteFunctionParams, setDeleteFunctionParams] = useState(null);

    const criterions = getObjectValue(`${dealingId}.stages.0.criterions`, formikProps.values, [])
    const priceCriterion = criterions.find(x => x.type === CRYTERIUM_TYPE.PRICE);
    const weightVisible = priceCriterion && priceCriterion.direction === PriceDirections.DESCENDING_BY_PRICE_ITEMS;
    const elements = getObjectValue(id, formikProps.values)
    const editable = getObjectValue('_editable', formikProps.values, true);

    const section = !!demandValidation && demandValidation.find((x) => x.section === DemandValidation.DEALINGS);
    const optionalItemsEnabled = !!section && section.optionalItemsEnabled;

    const criteriaSumError = getObjectValue(`${dealingId}._weightSum`, formikProps.errors, [])
    const isError = !!criteriaSumError;

    const handleAddItem = () => {
        setEditingItem(_.cloneDeep(newItem));
    }

    const handleShowItem = (index, option) => {
        let clonedItem;
        if (option) {
            if (elements[index].optionalItem) {
                clonedItem = _.cloneDeep(elements[index].optionalItem);
            } else {
                clonedItem = _.cloneDeep(newItem);
                clonedItem.type = ITEM_TYPES.OPTIONAL;
                clonedItem.quantity.uom = elements[index].quantity.uom;
            }
            clonedItem.baseItemId = elements[index].identity;
            clonedItem.baseItemName = elements[index].name;
        } else {
            clonedItem = _.cloneDeep(elements[index]);
        }
        setEditingItem(clonedItem);
    }

    const handleCloseEditItem = () => {
        setEditingItem(null);
    }

    const handleEditItem = (values) => {
        const dealing = getObjectValue(`${dealingId}.identity`, formikProps.values);
        if (!!editingItem.baseItemId) {
            const index = elements.findIndex(x => x.identity === editingItem.baseItemId);
            if (!!values.separateOfferValueThanBaseItem) {
                elements[index].optionalItem = {
                    ...values,
                    identity: !!values.identity && values.identity > 0 ? values.identity : -1
                }
            } else {
                elements[index].optionalItem = {
                    ...values,
                    identity: !!values.identity && values.identity > 0 ? values.identity : -1,
                    quantity: {
                        ...values.quantity,
                        uom: elements[index].quantity.uom
                    },
                    offerVatPredefined: elements[index].offerVatPredefined,
                    offerSourceType: elements[index].offerSourceType,
                    offerValue: elements[index].offerValue,
                    offerVatRate: elements[index].offerVatRate,
                    offerVatRateOther: elements[index].offerVatRateOther,
                    offerGrossValue: elements[index].offerGrossValue,
                    allowQuantityEditInOffer: elements[index].allowQuantityEditInOffer
                }
            }
        } else if (!editingItem.identity) {
            const mindIdFound = elements.map(e => e.identity).reduce((x1, x2) => x1 < x2 ? x1 : x2);
            const newId = mindIdFound < 0 ? (mindIdFound - 1) : -1;
            elements.push({
                ...values,
                identity: newId,
                dealing: dealing
            });
        } else {
            const index = elements.findIndex(x => x.identity === editingItem.identity);
            const oldItem = elements[index];
            elements[index] = {
                ...values,
                identity: oldItem.identity,
                dealing: oldItem.dealing,
                optionalItem: oldItem.optionalItem
            };
            if (!!elements[index].optionalItem && !elements[index].optionalItem.separateOfferValueThanBaseItem) {
                elements[index].optionalItem.quantity.uom = elements[index].quantity.uom;
                elements[index].optionalItem.offerVatPredefined = elements[index].offerVatPredefined;
                elements[index].optionalItem.offerSourceType = elements[index].offerSourceType;
                elements[index].optionalItem.offerValue = elements[index].offerValue;
                elements[index].optionalItem.offerVatRate = elements[index].offerVatRate;
                elements[index].optionalItem.offerVatRateOther = elements[index].offerVatRateOther;
                elements[index].optionalItem.offerGrossValue = elements[index].offerGrossValue;
                elements[index].optionalItem.allowQuantityEditInOffer = elements[index].allowQuantityEditInOffer;
            }
        }
        formikProps.setFieldValue(id, elements);
        setEditingItem(null);
    }

    const renderSingle = () => {
        return (
            <>
                <Divider/>
                <Typography
                    variant='body1'
                    className={classes.header}
                >
                    {Tr('positions')}
                </Typography>
                <SingleVariant
                    formikProps={formikProps}
                    id={id}
                    handleEditItem={handleShowItem}
                    weightVisible={weightVisible}
                    optionalItemsEnabled={optionalItemsEnabled}
                />
            </>
        )
    }

    useEffect(() => {
        if (elements.length < 2) {
            const elId = `${id}.0.name`
            formikProps.setFieldTouched(elId, false)
        }
        // eslint-disable-next-line
    }, [elements.length]);

    const showDeleteConfirm = (idParam, indexParam) => {
        setDeleteConfirm(true);
        setDeleteFunctionParams([idParam, indexParam]);
    }

    const doDeleteAfterConfirm = () => {
        setDeleteConfirm(false);
        removeFormikListElement(formikProps, deleteFunctionParams[0], deleteFunctionParams[1])
    }

    const renderMulti = () => {
        return (
            <>
                <Divider/>
                <Typography
                    variant='body1'
                    className={classes.header}
                >
                    {Tr('positions')}
                </Typography>
                {
                    elements.map((item, i) => {
                        return (
                            <React.Fragment key={`item.${item.identity}`}>
                                <MultiVariant
                                    formikProps={formikProps}
                                    id={id}
                                    index={i}
                                    handleEditItem={handleShowItem}
                                    weightVisible={weightVisible}
                                    showConfirmBeforeDelete={showDeleteConfirm}
                                    optionalItemsEnabled={optionalItemsEnabled}
                                />
                                {item.optionalItem &&
                                <MultiVariant
                                    formikProps={formikProps}
                                    id={id}
                                    index={i}
                                    option={true}
                                    handleEditItem={handleShowItem}
                                    weightVisible={weightVisible}
                                    showConfirmBeforeDelete={showDeleteConfirm}
                                    optionalItemsEnabled={optionalItemsEnabled}
                                />
                                }
                            </React.Fragment>
                        )
                    })
                }
            </>
        )
    }

    return (
        <>
            <GridBlock
                className={classes.root}
                column
            >
                {elements.length < 2 && elements[0].optionalItem == null ? renderSingle() : renderMulti()}
                <GridBlock justify='space-between'>
                    <AddButton
                        onClick={handleAddItem}
                        disabled={!editable}
                    >
                        {Tr('add_position')}
                    </AddButton>
                    {(isError) &&
                    <Typography variant='body1' color='error'>
                        {criteriaSumError}
                    </Typography>
                    }
                    <></>
                </GridBlock>
                <Divider
                    className={classes.divider}
                />
            </GridBlock>
            {!!editingItem && <ItemPopup
                editable={editable}
                onClose={handleCloseEditItem}
                onSubmit={handleEditItem}
                itemElement={editingItem}
                sectionItems={elements}
                weightVisible={weightVisible}
                priceType={priceType}
            />}
            {deleteConfirm && <Confirm
                open={deleteConfirm}
                onConfirm={doDeleteAfterConfirm}
                onCancel={() => {
                    setDeleteConfirm(false);
                    setDeleteFunctionParams(null);
                }}
                confirmText="positions_with_option_delete"
            />}
        </>)
}

PositionsSection.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation
}), {})(withStyles(style)(PositionsSection));